export enum SeverityStatus {
  High = "Vysoká",
  No = "Žádná",
}
